import { WidgetType } from '../domain/widget-type.model';
import { DevicePlacement } from '../domain/device-placement.model';
import { BridgeAdUnit } from '../domain/bridge-ad-unit.model';

export class DomainUtils {

  // static isVideo(adUnit: BridgeAdUnit) {
  //   return ['cnsmbl-video-970x250', 'cnsmbl-video-632x420', 'cnsmbl-video-632x420-vast', 'cnsmbl-video-vast', 'cnsmbl-video-footer', 'cnsmbl-video-responsive', 'cnsmbl-video-footer-mobile'].includes(adUnit.widgetName);
  // }

  //todo use this value from widget type
  static isVideoVast(adUnit: BridgeAdUnit) {
    return adUnit.widgetName.includes('-vast');
  }

  static getDfpVideoSizes() {
    return ['400x300v', '444x250v', '600x252v', '640x480v'];
  }

  static domainsStringToArrayUnique(domains: string) {
    return Array.from(new Set(domains.toLowerCase()
      .replace(/;/g, ',')
      .replace(/\n/g, ',')
      .replace(/\t/g, ',')
      .replace(/ /, ',')
      .split(',')))
      .filter(d => d);
  }

  static setWidgetTypeDisplayName(type: WidgetType) {
    DomainUtils.setWidgetTypesDisplayName([type]);
  }

  static setWidgetTypesDisplayName(types: WidgetType[]) {
    types.forEach(type => {
      type.displayName = type.displayName || (type.responsive ? type.name : `${type.width}x${type.height}`);
    });
  }

  static setWidgetTypesSize(types: WidgetType[]) {
    types.forEach(type => {
      type._size = type.responsive ? 'responsive' : `${type.width}x${type.height}`;
    });
  }

  static setWidgetTypeDevicePlacements(types: WidgetType[]) {
    types.forEach(type => {
      type._devicePlacements = type.devicePlacements ? type.devicePlacements.split(',').map(a => <DevicePlacement>a) : [];
    });
  }

  static generateVastConfigUrl(el: BridgeAdUnit) {
    const iu = el.gptTag;
    const sz = DomainUtils.getDfpVideoSizes().map(s => s.replace('v', '')).join('|');
    return `https://pubads.g.doubleclick.net/gampad/ads?iu=133810016,${iu}&env=vp&impl=s&correlator=&tfcd=0&npa=0&gdfp_req=1&output=vast&sz=${sz}&unviewed_position_start=1&description_url=%%DESCRIPTION_URL_ESC%%`;
  }
}
